module.exports = {
  brand: {
    name: "DJ RISE",
    slug: "djr",
    tagline: "Professional DJ Services",
    description:
      "Premium DJ services for weddings, corporate events, and private parties",
  },

  legal: {
    // Registered BC sole proprietorship (filed 2026-10-20). Contracts and the
    // legal_name_inline email block build their wording from these three.
    legalName: "Andrii Kukhar",
    businessName: "DJ RISE",
    registrationNumber: "FM1121698",
    legalLine: "Andrii Kukhar, operating as DJ RISE (BC Reg. FM1121698)",
    address: "3410-128 West Cordova Street",
    phone: "+1 (236) 995 - 1120",
    contactEmail: "andrewrisedj@gmail.com",
    eTransferEmail: "andriikukharv@gmail.com",
  },

  api: {
    baseURL: process.env.REACT_APP_API_URL || "http://localhost:4040",
    timeout: 30000,
  },

  branding: {
    primaryColor: "#43C6AC",
    secondaryColor: "#191654",
    accentColor: "#000C40",
    quaternaryColor: "#41295a",
    gradients: {
      primary: "linear-gradient(-45deg, #43C6AC, #191654, #000C40, #41295a)",
      card: "linear-gradient(-45deg, #43C6AC, #191654, #000C40, #41295a)",
    },
    logo: "/logo.png",
    favicon: "/favicon.ico",
  },

  theme: {
    mode: "dark",
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      h1: { fontSize: "2.5rem", fontWeight: 600 },
      h2: { fontSize: "2rem", fontWeight: 600 },
      h3: { fontSize: "1.5rem", fontWeight: 500 },
    },
  },

  features: {
    audio: true,
    gallery: true,
    reviews: true,
    events: true,
    adminPanel: true,
    soundEngineering: true,
    infoExpectProcess: true,
  },

  navigation: {
    items: [
      { name: "Home", path: "/", icon: "home" },
      { name: "Audio", path: "/audio", icon: "audiotrack" },
      { name: "Gallery", path: "/gallery", icon: "photo_library" },
      { name: "Events", path: "/events", icon: "event" },
      { name: "Reviews", path: "/reviews", icon: "star" },
      { name: "Booking", path: "/booking", icon: "book_online" },
    ],
  },

  social: {
    instagram: {
      url: "https://www.instagram.com/vandjrise",
    },
    facebook: {
      url: "https://www.facebook.com/andrewrisedj",
    },
    youtube: {
      url: "https://www.youtube.com/@vandjrise",
    },
    mixcloud: {
      url: "https://www.mixcloud.com/vandjrise",
    },
    housemusic: {
      url: "https://www.risedj.club/",
    },
  },

  mixcloud: {
    embeds: [
      "https://player-widget.mixcloud.com/widget/iframe/?hide_cover=1&light=1&feed=%2Fvandjrise%2Fdj-rise-wedding-reception-june-20th-2025%2F",
      "https://player-widget.mixcloud.com/widget/iframe/?hide_cover=1&light=1&feed=%2Fvandjrise%2Fdj-rise-ucc-birthday-party-old-school-hip-hop-rnb%2F",
      "https://player-widget.mixcloud.com/widget/iframe/?hide_cover=1&light=1&feed=%2Fvandjrise%2Fdj-rise-kids-bowl-club-oct-23-2024%2F",
      "https://player-widget.mixcloud.com/widget/iframe/?hide_cover=1&light=1&feed=%2Fvandjrise%2Fdj-rise-vgc-student-party-july-07-2024%2F",
      "https://player-widget.mixcloud.com/widget/iframe/?hide_cover=1&light=1&feed=%2Fvandjrise%2Fdj-rise-00s-rnb-disco-hits%2F",
      "https://player-widget.mixcloud.com/widget/iframe/?hide_cover=1&light=1&feed=%2Fvandjrise%2Frise-dj-nice-house-music-001%2F",
      "https://player-widget.mixcloud.com/widget/iframe/?hide_cover=1&light=1&feed=%2Fvandjrise%2Fdj-rise-oldies-dance-promo-mix%2F",
    ],
  },

  domains: {
    frontend: process.env.REACT_APP_FRONTEND_URL || "http://localhost:3000",
    production: "https://www.djrise.party",
  },
};
